import React from 'react'
import './Text.css'

export default class Text extends React.PureComponent {
  render () {
    const { value, ui } = this.props.field
    let className = ''
    className = ui && ui.subText ? 'sub-text' : className
    className = ui && ui.irregularShape ? 'irregular-shape' : className
    className = ui && ui.className ? `${className} ${ui.className}` : className

    return (
      <div className={className}><p> { value } </p></div>
    )
  }
}